import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';

/**
 * Sends a photo_editor_open analytics event.
 * Fires when user clicks "Open in Editor" to open content in the photo editor.
 */
const sendPhotoEditorOpenAnalytics = () => {
  try {
    const params = {
      source: MINIAPP_PACKAGE_ID,
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.PHOTO_EDITOR_OPEN,
      params,
    });
  } catch {
    // Failed to send analytics
  }
};

export default sendPhotoEditorOpenAnalytics;
